module.exports = __webpack_public_path__ + "static/img/ZA@2x.91ccc96c.jpg";